import React from 'react';
import './index.scss';

const ColorTile = ({ color = 'white' }) => (
    <div className='ColorTile' style={{ background: color }} />
);

export default ColorTile;
